<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Pegawai</label>
            <div class="col-sm-8">
              <input
                class="form-control form-control-sm"
                v-model.lazy="search"
                placeholder="Cari Pegawai"
                @keyup.enter="onRefresh" />
            </div>
          </div>
        </div>
        
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tipe Pegawai</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.employeeTypeId"
                :options="listEmployeeTypes"
                :reduce="item => item.ID"
                label="Name" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Tahun</label>
            <div class="col-sm-8">
              <v-select v-model="filter.year" :options="$constant.LIST_YEARS" />
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-center">Bulan</label>
            <div class="col-sm-8">
              <v-select
                v-model="filter.month"
                :options="$constant.LIST_MONTHS"
                :reduce="item => item.ID"
                label="Name" />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onPrint" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>

          <a class="btn btn-sm btn-success btn-icon-split text-dark" @click="exportToExcel" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Excel <b-spinner small v-show="isLoading" /></span>
          </a>
        </div>
      </div>
    </div>


    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      :filter="filter"
      @onSelectItem="selectedItem = $event" />
      <!-- isSalaryReport -->

    <b-modal id="modalPrint" hide-footer no-close-on-backdrop size="xl" title="Cetak Gaji Pegawai" header-class="bg-light text-primary py-1">

      <iframe ref="printFrame" id="printFrame" class="w-100" height="600" name="printFrame"></iframe>

      <div class="text-center">
        <button class="btn btn-primary" @click="printToPDF">Print</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/salary-monthly',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Pegawai', stickyColumn: true, variant: 'light' },
        { key: 'FirstAssignment', label: 'TMT', formatter: value => this.$helper.formatDate(value) },
        // { key: 'LastAssignment', label: 'TMT Baru', formatter: value => this.$helper.formatDate(value) },
        { key: 'MonthOfWork', label: 'Masa Kerja', formatter: value => {
          if (!value) {
            return '-'
          } else {
            return `${Math.floor(value / 12)} Thn, ${value % 12} Bln`
          }
        }},
        { key: 'Education', label: 'Pendidikan' },
        { key: 'TotalSalary', label: 'Besarnya Honor', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'info'  },
        { key: 'SalaryCut', label: 'Potongan', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutBasis', label: 'Basis', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutIdi', label: 'IDI', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutPpni', label: 'PPNI', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutSimpanPinjamKoperasi', label: 'Simpan Pinjam Koperasi', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutIuranKoperasi', label: 'Iuran Koperasi', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutBarangKoperasi', label: 'Barang Koperasi', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        // { key: 'CutBpjs', label: 'BPJS', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'danger' },
        { key: 'TrueSalary', label: 'Jumlah Bersih', formatter: value => value ? this.$helper.formatRupiah(value) : '-', variant: 'success'  },
        { key: 'BankAccountNumber', label: 'No. Rekening' }
      ],
      selectedItem: null,
      search: '',
      listEmployeeTypes: [],
      filter: {
        employeeTypeId: 2,
        year: (new Date()).getFullYear(),
        month: (new Date()).getMonth() + 1
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/employee-type'),
      ]).then(this.$axios.spread((...res) => {
        this.listEmployeeTypes = res[0].data
      }))
    },
    onPrint () {
      this.$bvModal.show('modalPrint')

      this.generateReport().then(data => {

        this.$nextTick(function () {
          this.$refs.printFrame.srcdoc = data
        })
      })
    },

    generateReport () {
      const params = this.filter

      return this.$axios.get(this.apiUrl, { params }).then(res => {

        const head = `
          <h2 class="text-center">DAFTAR PENERIMA HONOR TENAGA KONTRAK KERJA</h2>
          <h2 class="text-center">RSUD Dr. SOEGIRI LAMONGAN</h2>
          <h2 class="text-center underlined">BULAN ${this.$helper.getMonthName(this.filter.month)} ${this.filter.year}</h2>
          <br>

          <table border="1">
          <tr>
            <th>NO</th>
            <th>Nama Pegawai</th>
            <th>No. Rekening</th>
            <th>TMT</th>
            <th>Masa Kerja</th>
            <th>Besarnya Honor</th>
            <th>Potongan</th>
            <th>Jumlah Bersih</th>
          </tr>
        `
            // <th>Pendidikan</th>

        let totalSalary = 0
        let totalSalaryCut = 0
        let totalTrueSalary = 0

        let content = ''
        for (var i = 0; i < res.data.length; i++) {
          content += `
            <tr>
              <td>${i+1}</td>
              <td>${res.data[i].Name}</td>
              <td>${res.data[i].BankAccountNumber}</td>
              <td>${this.$helper.formatDate(res.data[i].FirstAssignment)}</td>
              <td>${Math.floor(res.data[i].MonthOfWork / 12)} Thn, ${res.data[i].MonthOfWork % 12} Bln</td>
              <td nowrap>${this.$helper.formatRupiah(res.data[i].TotalSalary)}</td>
              <td nowrap>${this.$helper.formatRupiah(res.data[i].SalaryCut)}</td>
              <td nowrap>${this.$helper.formatRupiah(res.data[i].TrueSalary)}</td>
            </tr>
          `
              // <td>${res.data[i].Education}</td>

          totalSalary += res.data[i].TotalSalary
          totalSalaryCut += res.data[i].SalaryCut
          totalTrueSalary += res.data[i].TrueSalary
        }

        content += `
          <tr style="font-weight: bold;">
            <td colspan="5">TOTAL</td>
            <td>${this.$helper.formatRupiah(totalSalary)}</td>
            <td>${this.$helper.formatRupiah(totalSalaryCut)}</td>
            <td>${this.$helper.formatRupiah(totalTrueSalary)}</td>
          </tr>
        `

        const foot = `
          </table>

          <br><br>
          <div class="box" style="float: left;">
            <h4>MENGETAHUI / MENYETUJUI</h4>
            <h4>DIREKTUR</h4>
            <h4>RSUD Dr. SOEGIRI LAMONGAN</h4>
            <br><br><br>

            <h4>dr. MOH. CHAIDIR ANNAS, M.Mkes.</h4>
            <h4>PEMBINA TINGKAT I</h4>
            <h4>NIP. 19661113 199703 1 002</h4>
          </div>

          <div class="box" style="float: right;">
            <h4>Lamongan, &nbsp; </h4>
            <h4>BENDAHARA PENGELUARAN</h4>
            <h4>RSUD Dr. SOEGIRI LAMONGAN</h4>
            <br><br><br>

            <h4>REZHA GREYA WINDINATA, SE.</h4>
            <h4>PENATA MUDA</h4>
            <h4>NIP. 19890618 201101 1 003</h4>
          </div>
        `

        return this.$constant.TEMPLATE_PRINT_HEADER
          + head
          + content
          + foot
          + this.$constant.TEMPLATE_PRINT_FOOTER
      })
    },

    printToPDF () {
      window.frames['printFrame'].print()
    },

    exportToExcel (e) {
      const elem = e.currentTarget

      if (!elem.getAttribute('download')) {
        this.generateReport().then(data => {

          let excelContent = data

          const fileName = `gaji-pegawai-${this.$helper.getMonthName(this.filter.month)}-${this.filter.year}.xls`

          excelContent = excelContent.replace(/<A[^>]*>|<\/A>/g, '')//remove if u want links in your table
          excelContent = excelContent.replace(/<img[^>]*>/gi,'') // remove if u want images in your table
          excelContent = excelContent.replace(/<input[^>]*>|<\/input>/gi, '') // reomves input params

          const ua = window.navigator.userAgent
          const msie = ua.indexOf('MSIE ')

          // If Internet Explorer
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            txtArea1.document.open('txt/html','replace')
            txtArea1.document.write(excelContent)
            txtArea1.document.close()
            txtArea1.focus() 
            
            txtArea1.document.execCommand('SaveAs', true, fileName)
          }  
          else {
            // const url = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(excelContent))  
            const url = 'data:application/vnd.ms-excel,' + escape(excelContent)
            elem.setAttribute('href', url)
            elem.setAttribute('download', fileName)

            elem.click()

            return false
          }
        })

      }

      return false
    }    
  }
}
</script>
